import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { getParameterByName } from '../../../../helpers/location';
import ourStaff from '../../../../helpers/ourStaff';
import MatchesListWidget from '../Widgets/MatchesList'

const championshipsByPlatform = { 'mpg': 1, 'mln': 2, 'mgd': 3};
const MatchesDashboard = props => {
    return !props.location.search ? (
        <Redirect to={{
            pathname: '/matches',
            search: `?championship=${championshipsByPlatform[props.user.mainPlatform]}`,
        }}/>
    ) : (
        <div id="matches-dashboard">
            <header className="content-header">
                <h1>
                    Matches
                    <small>dashboard</small>
                </h1>
                <ol className="breadcrumb">
                    <li><i className="fa fa-desktop"/> On Site</li>
                    <li className="text-bold"><Link to="/matches">Matches</Link></li>
                </ol>
            </header>
            <section className="content">
                <div className='row'>
                    <div className="col-lg-6">
                        <MatchesListWidget
                            championship={parseInt(getParameterByName('championship', props.location.search), 10)}
                        />
                    </div>
                </div>
            </section>
        </div>
    )
};

MatchesDashboard.propTypes = {
    user: PropTypes.object.isRequired
};

export default connect(
    state => ({ user: ourStaff[state.authentication.userId] || state.authentication.user || {} }),
    dispatch => ({ dispatch }),
)(MatchesDashboard);



// WEBPACK FOOTER //
// ./src/pages/OnSite/Matches/Dashboard/index.js